import { APP_CONFIG } from '../../../core/services/app-config.service';

export const SERVICE_MARKETPLACE_URL = 'https://blueshieldca.service-now.com/essp?id=sc_cat_item&sys_id=0616e1d06f8add006bcb2fa0be3ee454&table=sc_cat_item&searchTerm=cs%20admin';
export const AD_ACCESS_REQUEST_URL = 'https://blueshieldca.service-now.com/essp?id=sc_cat_item&sys_id=4de16fadcf390790e092f35d5d851c74&table=sc_cat_item&searchTerm=CS%20Web%20Administration';

export const CONSTANTS = {
    INVALID_CREDENTIALS: 'We didn\'t recognize the username or password you entered. Please try again.',
    INVALID_ACCOUNT: 'Your CS admin account is in a disabled/inactive status. Please raise a new access ticket using this <a href="' + SERVICE_MARKETPLACE_URL + '" target="_blank">link</a>. Please make sure you select the request type category as \'New User.\'',
    INVALID_ACCOUNT_AZURE: 'Your CS admin account is in a disabled/inactive status. Please raise a new access ticket using this <a href="' + AD_ACCESS_REQUEST_URL + '" target="_blank">link</a>. Please make sure you select the request type category as \'New User.\'',
    NO_AD_GROUP_ACCESS: 'You do not have any CS Admin access groups assigned to your account. Please raise a new access request using this <a href="' + AD_ACCESS_REQUEST_URL + '" target="_blank">link</a> to get the appropriate access.',
    LOGIN_EXECEPTION: 'Exception occurred while connecting to Active Directory. Please contact Helpdesk.',
    HOME_URL: '/home',
    USER_ID_FIELD: 'userId',
    PASSWORD_FIELD: 'password',
    EMPTY: '',
    UNAUTHORIZED_CODE: '601',
    ACCOUNT_INACTIVE_CODE: '603',
    USER_NOT_FOUND_CODE: '404',
    SALESFORCE_SSO_USER: 'SALESFORCE_SSO_USER',
    AZURE_SSO_USER: 'AZURE_SSO_USER',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    UNAUTHORIZED_ACCESS: 'UNAUTHORIZED ACCESS',
    UNAUTHORIZED_AUDIT_TXT: 'Unauthorized access attempt to'
};

export const SPLUNK = {
    LOGIN_SUCCESS_ID: '1102',
    LOGIN_FAILURE_ID: '1103',
    USER_PROFILE_SUCCESS_ID: '1104',
    USER_PROFILE_FAILURE_ID: '1105',
    SALES_FORCE_SSO_SUCCESS_ID: '1106',
    SALES_FORCE_SSO_FAILURE_ID: '1107',
    UNAUTH_URL_ACCESS_ATTEMPT_ID: '1108',
    LOGIN_SUCCESS_EVENT_CD: 'DPADMIN_LOGIN_SUCCESS',
    LOGIN_FAILURE_EVENT_CD: 'DPADMIN_LOGIN_FAILURE',
    USER_PROFILE_SUCCESS_EVENT_CD: 'DPADMIN_USER_PROFILE_SUCCESS',
    USER_PROFILE_FAILURE_EVENT_CD: 'DPADMIN_USER_PROFILE_FAILURE',
    SALES_FORCE_SSO_SUCCESS_EVENT_CD: 'DPADMIN_SALES_FORCE_SSO_SUCCESS',
    SALES_FORCE_SSO_FAILURE_EVENT_CD: 'DPADMIN_SALES_FORCE_SSO_FAILURE',
    UNAUTH_URL_ACCESS_ATTEMPT_CD: 'DPADMIN_URL_UNAUTHORIZED_ACCESS_ATTEMPT',
    LOGIN_SUCCESS_EVENT_DESC: 'DPAdmin Login Successful',
    LOGIN_FAILURE_EVENT_DESC: 'DPAdmin Login Failed',
    USER_PROFILE_SUCCESS_EVENT_DESC: 'DPAdmin User Profile Fetch Success',
    USER_PROFILE_FAILURE_EVENT_DESC: 'DPAdmin User Profile Fetch Failed',
    SALES_FORCE_SSO_SUCCESS_EVENT_DESC: 'Sales Force Inbound SSO Success',
    SALES_FORCE_SSO_FAILURE_EVENT_DESC: 'Sales Force Inbound SSO Failed',
    AZURE_SSO_SUCCESS_ID: '1109',
    AZURE_SSO_FAILURE_ID: '1110',
    AZURE_SSO_SUCCESS_EVENT_CD: 'DPADMIN_AZURE_SSO_SUCCESS',
    AZURE_SSO_FAILURE_EVENT_CD: 'DPADMIN_AZURE_SSO_FAILURE',
    AZURE_SSO_SUCCESS_EVENT_DESC: 'Azure AD Inbound SSO Success',
    AZURE_SSO_FAILURE_EVENT_DESC: 'Azure AD Inbound SSO Failed',
    UNAUTH_URL_ACCESS_ATTEMPT_DESC: 'Unauthorized access attempt to DP Admin authorized URL',
}

export const COOKIE = {
    DP_ADM_USER_NAME: 'DPADMUSR',
    DP_ADM_USER_ID: 'DPADMUID',
    DP_ADM_TOKEN: 'DPADMTKN',
    DP_ADM_SID: 'DPADMSID',
    DP_ADM_AL: 'DPADMAL',
    BENEFIT_LOOKUP_URL: 'benefitLookupUrl',
    ADLOGIN: 'adLogin'
};

/**
 * Builds an AD groups object for the given environment suffix.
 * Pass '' for production, '-opt' for Opstest, '-qa1' for QA1, '-qa2' for QA2, etc.
 * Each group name is the production base name appended with the suffix.
 */
export function buildAdGroups(suffix: string) {
    return {
        SUPER_ADMIN: `appsec-csa-super-admn-grp${suffix}`,
        MANAGE_CSA_USERS_REP: `appsec-csa-csadmn-rep-grp${suffix}`,
        MANAGE_CSA_USERS_ADMIN: `appsec-csa-csadmn-admn-grp${suffix}`,
        BENEFIT_LOOKUP_REP: `appsec-csa-csadmn-benefit-rep-grp${suffix}`,
        MEMBER_PAYMENT_ADMIN: `appsec-csa-member-pymt-admn-grp${suffix}`,
        MEMBER_ADMIN: `appsec-csa-member-admn-grp${suffix}`,
        MEMBER_REP: `appsec-csa-member-rep-grp${suffix}`,
        PROVIDER_REP: `appsec-csa-provider-rep-grp${suffix}`,
        PROVIDER_ADMIN: `appsec-csa-provider-admn-grp${suffix}`,
        PROVIDER_REP_TAX: `appsec-csa-provider-rep-tax-grp${suffix}`,
        EMPLOYER_REP: `appsec-csa-employer-rep-grp${suffix}`,
        EMPLOYER_ADMIN: `appsec-csa-employer-admn-grp${suffix}`,
        EMPLOYER_RPT: `appsec-csa-employer-rpt-grp${suffix}`,
        SELF_FUNDED_ADMIN: `appsec-csa-tpa-admn-grp${suffix}`,
        TPA_REP: `appsec-csa-tpa-rep-grp${suffix}`,
        PRODUCER_REP: `appsec-csa-producer-rep-grp${suffix}`,
        PRODUCER_DSA: `appsec-csa-producer-dsa-grp${suffix}`,
        PRODUCER_ADMIN: `appsec-csa-producer-admn-grp${suffix}`,
        PROSPECT_REP: `appsec-csa-prospect-rep-grp${suffix}`,
        PROSPECT_ADMIN: `appsec-csa-prospect-admn-grp${suffix}`,
        MANAGE_OEP_ADMIN: `appsec-csa-manage-oep-admn-grp${suffix}`,
    };
}

/**
 * Returns the AD groups for the active deployment environment.
 * Reads APP_CONFIG.AD_GROUP_SUFFIX at call-time (safe after APP_INITIALIZER runs).
 * '-prod' is the sentinel value for production — mapped to '' (no suffix on prod group names).
 * NPE environments use their own literal suffix: '-opt', '-qa1', '-qa2', etc.
 */
export function getActiveAdGroups() {
    const suffix = APP_CONFIG.AD_GROUP_SUFFIX;
    return buildAdGroups(suffix === '-prod' ? '' : suffix);
}

/**
 * Azure AD Groups for Production Environment
 */
export const PROD_AD_GROUPS = buildAdGroups('');